import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { JobPipeline } from '@/types/pipeline';

export function useJobPipelines(options: { enabled?: boolean } = {}) {
  return useApiQuery<JobPipeline[]>({
    queryKey: jobPipelineKeys.lists(),
    enabled: options.enabled ?? true,
    queryFn: async () => {
      const data = await apiGet<JobPipeline[] | { data: JobPipeline[] }>(
        operationsClient,
        jobPipelineEndpoints.list(),
      );
      return Array.isArray(data) ? data : (data?.data ?? []);
    },
  });
}
